define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/NumberController",
	"csi/view"

], function(declare,_,NumberController,csiView) {

	return declare(NumberController, {

		postProcessSuccess: function() {
			var refNode = this.refNode;
			var sourceView = this.widget;
			var viewIds = ["Evaluation", "EvaluationBySample"];

			sourceView.redrawNode(this.refNode);

			_.each(csiView.getViews(), function(view) {
				if ((view != sourceView) && _.contains(viewIds, view.defView.getId()) && view.bViewed){
					view.redrawData();
				}
			});
		}
	});
});